import React from 'react';
import styled from 'styled-components';

import { HeaderContainer, HeaderMixin } from '../../shared/styles';
import {
  ActionColumn,
} from '../../companies/companies-components/styles';
import { NameColumn, PositionColumn } from './styles';

const NameColumnHeader = styled(NameColumn)`
  ${HeaderMixin}
`;

const PositionColumnHeader = styled(PositionColumn)`
  ${HeaderMixin}
`;

export default function PartnerHeader() {
  return (
    <HeaderContainer>
      <NameColumnHeader>Name</NameColumnHeader>
      <PositionColumnHeader>Job Title</PositionColumnHeader>
      <ActionColumn />
    </HeaderContainer>
  );
}
